import React, { useEffect, useState } from 'react';
import { saveCustomer } from './customers';

const emptyCustomer = {
  name: '', email: '', phone: '+65', company: '', address: '',
  status: 'New', notes: ''
};

export default function CustomerEditor({ customer, onClose, onSaved }) {
  const [values, setValues] = useState(customer || emptyCustomer);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    setValues(customer || emptyCustomer);
    setError('');
  }, [customer]);

  function update(event) {
    setValues((current) => ({ ...current, [event.target.name]: event.target.value }));
  }

  async function submit(event) {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      const saved = await saveCustomer(values);
      onSaved(saved);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="crm-overlay" onMouseDown={(event) => event.target === event.currentTarget && onClose()}>
      <section className="crm-editor" role="dialog" aria-modal="true" aria-labelledby="crm-editor-title">
        <div className="crm-editor-top">
          <div><span className="crm-kicker">CUSTOMER RECORD</span><h2 id="crm-editor-title">{customer ? 'Edit customer' : 'New customer'}</h2></div>
          <button type="button" className="crm-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <form onSubmit={submit}>
          <div className="crm-form-grid">
            <label>Full name *<input name="name" value={values.name} onChange={update} required maxLength="200" /></label>
            <label>Company (optional)<input name="company" value={values.company} onChange={update} maxLength="200" /></label>
            <label>Email<input name="email" type="email" value={values.email} onChange={update} maxLength="250" /></label>
            <label>Phone<input name="phone" type="tel" value={values.phone} onChange={update} maxLength="50" /></label>
            <label>Status<select name="status" value={values.status} onChange={update}>
              {['New', 'Active', 'Follow-up', 'Completed'].map((status) => <option key={status}>{status}</option>)}
            </select></label>
            <label className="crm-wide">Address<input name="address" value={values.address} onChange={update} maxLength="500" /></label>
            <label className="crm-wide">Notes<textarea name="notes" value={values.notes} onChange={update} rows="5" /></label>
          </div>
          {error && <p className="crm-error" role="alert">{error}</p>}
          <div className="crm-form-actions"><button type="button" className="crm-secondary" onClick={onClose}>Cancel</button><button type="submit" disabled={busy}>{busy ? 'Saving…' : 'Save customer'}</button></div>
        </form>
      </section>
    </div>
  );
}